// @mui/icons-material
import SentimentSatisfied from '@mui/icons-material/SentimentSatisfied';

export const routes = [
  {
    path: '/jeunes',
    name: 'Mes jeunes',
    icon: SentimentSatisfied,
  },
];
